import React from "react";
// Import global styles and Tailwind
import "./tailwind.css";
import "./styles/global.css";
import "./styles/forms.css";
import "./styles/navigation.css";
import "./styles/event-builder.css";
import "./styles/legal.css";
import "./styles/hero.css";
import "./styles/glowing-border.css";
import "./styles/mobile-styles.css";
// Polyfill Node.js Buffer for gray-matter front-matter parsing
import { Buffer } from 'buffer';
if (typeof window !== 'undefined' && !window.Buffer) window.Buffer = Buffer;
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { BrandingProvider } from "./context/BrandingContext";
import App from "./App";

const root = document.getElementById("app");

// Auto-attach auth header to same-origin API calls
if (typeof window !== 'undefined' && window.fetch) {
  const _fetch = window.fetch;
  // Remove global fetch override; use apiFetch in components instead
}

if (root) {
  try {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <BrowserRouter>
          <BrandingProvider>
            <App />
          </BrandingProvider>
        </BrowserRouter> {/* ✅ Ensure BrowserRouter is ONLY here */}
      </React.StrictMode>
    );
    console.log("✅ App successfully mounted!");
  } catch (error) {
    console.error("❌ Error mounting app:", error);
  }
} else {
  console.error("❌ Root #app not found in DOM!");
}
